








































import { Component, Vue } from 'vue-property-decorator';
import SearchCompanyItem from '@/views/SearchCompanyItem.vue';
import search from '@/store/modules/search';
import user from '@/store/modules/user';
import {PortfolioCompany} from '@/store/models';
import SearchPortfolioCompanyItem from '@/views/SearchPortfolioCompanyItem.vue';
@Component({
  components: {SearchCompanyItem, SearchPortfolioCompanyItem},
})
export default class Search extends Vue {
  async mounted() {
    await user.setActiveSie(null);
  }
  async updateCompany(OrgNr: string) {
    await user.setActiveExternalUser(null);
    await user.addCompany(OrgNr);
    await search.setTerm('');
    await this.$router.push({ name: 'overview', params: { OrgNr } });
  }
  async gotoCompany(OrgNr: string) {
    await user.setActiveExternalUser(null);
    await search.setTerm('');
    await this.$router.push({ name: 'overview', params: { OrgNr } });
  }
  get pendingSearch() {
    return search.pending;
  }
  get pendingFetch() {
    return user.fetchingData;
  }
  get result() {
    return search.result;
  }
  get term() {
    return search.term;
  }
  get companies(): PortfolioCompany[] | null {
    if (!user.companies || this.term === '') { return []; }

    const filter = this.term;
    return user.companies.filter((c: PortfolioCompany, index: number, array: PortfolioCompany[]) => {
      if (!filter) { return true; }
      if (c.OrgNr.includes(filter)) { return true; }
      if (c.Name.toLowerCase().includes(filter)) { return true; }
      return false;
    }).slice(0, 50);
  }
  get allCompanies(): PortfolioCompany[] | null {
    const companies = user.companies;
    if (companies === null) {
      return null;
    }
    return companies.sort( (a: PortfolioCompany, b: PortfolioCompany) => a.Name.localeCompare(b.Name));
  }
}
